export enum ElementTypeValue {
  PRODUCT = "dd6604a5-2a2c-4da9-b505-f22c1651e21e",
  UPGRADE = "96f20c81-d6dc-45e1-9fe9-76ca73c0986b",
  DIRECT_SHIPMENT_COMPENSATION = "859c754e-b58e-42df-ba89-7dceb9607923",
}
